
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("22wE9", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $c81e0f36b1975a6f$export$2cd8252107eb640b; });
// ====================================================================================
// CCM19 JavaScript Module
// ====================================================================================

var $h1D2Q = parcelRequire("h1D2Q");
// example code for the module
// <script
//   type="text/x-ccm-loader"
//   data-ccm-loader-group="d.vinci"
//   data-ccm-loader-src="https://..."
//   data-ccm-card="true"
//   data-ccm-ref=".dvinci-job-widget"
//   data-ccm-title="<p class='title'><strong>Stellenangebote via D.Vinci</strong></p>"
//   data-ccm-text="Um Ihnen unsere aktuellen Stellenangebote anzeigen zu können benötigen wir Ihre Zustimmung zur Datenverarbeitung durch D.Vinci.\nBitte Stimmen Sie diesen zu."
//   data-ccm-button="Cookie-Zustimmung ändern"
//   ></script>
// <div class="dvinci-job-widget" />
const $c81e0f36b1975a6f$var$BUTTON_CLASS = "btn";
const $c81e0f36b1975a6f$var$DEFAULT_TEXT = "Dieses Element ben\xf6tigt eine Zustimmung zur Datenverarbeitung.";
const $c81e0f36b1975a6f$var$DEFAULT_BUTTON_TEXT = "Cookie-Zustimmung \xe4ndern";
const $c81e0f36b1975a6f$var$isHTML = (str)=>/<[a-z][\s\S]*>/i.test(str);
const $c81e0f36b1975a6f$var$createInformationCard = (group, data)=>{
    const cardTitle = data.ccmTitle || group;
    const titleHTML = $c81e0f36b1975a6f$var$isHTML(cardTitle) ? cardTitle : `<h2>${cardTitle}</h2>`;
    const cardText = data.ccmText || $c81e0f36b1975a6f$var$DEFAULT_TEXT;
    let textHTML = $c81e0f36b1975a6f$var$isHTML(cardText) ? cardText : `<p>${cardText}</p>`;
    textHTML = textHTML.replace(/(\r\n|\r|\n|\\n)/g, "<br/>");
    const card = document.createElement("div");
    card.className = "ccm-info-card";
    card.setAttribute("ccm-data-group", group);
    card.innerHTML = `${titleHTML}${textHTML}`;
    const button = document.createElement("button");
    button.className = `ccm-info-button ${$c81e0f36b1975a6f$var$BUTTON_CLASS}`;
    button.textContent = data.ccmButton || $c81e0f36b1975a6f$var$DEFAULT_BUTTON_TEXT;
    button.onclick = ()=>CCM.openControlPanel();
    card.appendChild(button);
    return card;
};
const $c81e0f36b1975a6f$var$handleContentReload = (data)=>{
    if (data.ccmCard !== "true") return;
    if (!data.ccmRef) return;
    const hasContent = Array.from(document.querySelectorAll(data.ccmRef)).some((el)=>el.innerHTML.trim() !== "");
    if (hasContent) window.location.reload();
};
const $c81e0f36b1975a6f$var$processGroupElement = (element, group, isAccepted)=>{
    if (!element || !element.dataset) return;
    if (element.dataset.ccmCard !== "true") return;
    const groupElements = document.querySelectorAll(`[data-ccm-loader-group="${group}"]`);
    if (groupElements.length === 0) return;
    groupElements.forEach((el)=>{
        if (el.dataset.ccmCard !== "true") return;
        let infoCard = el.parentElement.querySelector(".ccm-info-card");
        if (!infoCard) {
            const newInfoCard = $c81e0f36b1975a6f$var$createInformationCard(group, el.dataset);
            el.parentElement.appendChild(newInfoCard);
            infoCard = el.parentElement.querySelector(".ccm-info-card");
        }
        if (isAccepted) {
            infoCard.style.setProperty("display", "none");
            return;
        } else $c81e0f36b1975a6f$var$handleContentReload(el.dataset);
    });
};
const $c81e0f36b1975a6f$var$processEvent = ()=>{
    const embeddings = CCM.acceptedEmbeddings;
    if (!(embeddings === null || embeddings === void 0 ? void 0 : embeddings.length)) return;
    const groups = [
        ...new Set(Array.from(document.querySelectorAll("[data-ccm-loader-group]")).map((el)=>el.getAttribute("data-ccm-loader-group")).filter(Boolean))
    ];
    groups.forEach((group)=>{
        const groupElements = document.querySelectorAll(`[data-ccm-loader-group="${group}"]`);
        if (groupElements.length === 0) return;
        const normalizedGroup = group.trim().toLowerCase();
        const isAccepted = embeddings.some((e)=>{
            let name = e.name.trim().toLowerCase();
            return name.includes(normalizedGroup);
        });
        groupElements.forEach((el)=>$c81e0f36b1975a6f$var$processGroupElement(el, group, isAccepted));
    });
};
const $c81e0f36b1975a6f$export$2cd8252107eb640b = ()=>{
    (0, $h1D2Q.domReady)().then(()=>{
        if (typeof CCM === "undefined") return;
        const hasGroups = document.querySelector("[data-ccm-loader-group]");
        if (!hasGroups) return;
        $c81e0f36b1975a6f$var$processEvent();
        [
            "ccm19WidgetLoaded",
            "ccm19WidgetClosed"
        ].forEach((event)=>{
            window.addEventListener(event, $c81e0f36b1975a6f$var$processEvent);
        });
    });
};

});
parcelRegister("h1D2Q", function(module, exports) {

$parcel$export(module.exports, "domReady", function () { return $c650d1302b554f6f$export$d680cb6eec13a7c7; });
const $c650d1302b554f6f$export$d680cb6eec13a7c7 = ()=>new Promise((resolve)=>{
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });

});



//# sourceMappingURL=ccm19.3e324d68.js.map
